import { apiEndpoint, retryApi } from ".";

export interface UpdateEntryRequest {
  readonly name: string;
  readonly value: string;
  readonly type?: "String" | "SecureString";
  readonly skipRetry?: boolean;
  readonly lastValue?: string;
  readonly forceSave?: boolean;
}

export interface UpdateEntryResponse {
  readonly message: string;
  readonly version?: number;
}

export async function updateEntry(
  req: UpdateEntryRequest,
): Promise<UpdateEntryResponse | undefined> {
  const token = localStorage.getItem("authToken");
  if (token) {
    const response = await fetch(
      `${apiEndpoint}/parameter/${encodeURIComponent(req.name)}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(req),
      },
    );

    if (!response.ok) {
      if (
        response.status === 429 &&
        response.statusText === "Too Many Requests"
      ) {
        return undefined;
      }
      if ([401, 403].includes(response.status) && !req.skipRetry) {
        return retryApi({
          func: updateEntry,
          funcProps: req,
          response,
          token,
        });
      }
      if (response.status === 400) {
        const r = await response.json();
        if (JSON.parse(r).error === "The conditional request failed") {
          throw new Error("The conditional request failed");
        }
      }
      throw new Error(`Failed to update parameter: ${response.statusText}`);
    }

    return (await response.json()) as UpdateEntryResponse;
  }
}
